import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

/**
 * Detect whether the app is running as an installed PWA (standalone display
 * mode or iOS Safari home-screen app). PWA installs get the long-lived
 * "mobile" session; everything else (desktop, mobile browser, tablet browser)
 * gets the standard short-lived "web" session.
 */
export const detectDeviceType = () => {
    try {
        const isStandalone =
            (typeof window !== 'undefined' &&
                window.matchMedia &&
                window.matchMedia('(display-mode: standalone)').matches) ||
            (typeof window !== 'undefined' && window.navigator.standalone === true);
        return isStandalone ? 'mobile' : 'web';
    } catch (e) {
        return 'web';
    }
};

export const refreshToken = async () => {
    try {
        const refreshToken = localStorage.getItem('refresh_token');
        if (!refreshToken) return null;

        const response = await axios.post(`${API_URL}/auth/refresh/`, {
            refresh: refreshToken
        });

        if (response.data.access && response.data.refresh) {
            localStorage.setItem('access_token', response.data.access);
            localStorage.setItem('refresh_token', response.data.refresh);
            return response.data.access;
        }
        return null;
    } catch (error) {
        console.error('Token refresh failed:', error);
        return null;
    }
};

const getAuthHeader = () => {
  try {
    const token = localStorage.getItem('access_token');
    if (!token) throw new Error('No access token found');
    
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    };
  } catch (error) {
    console.error('Error creating auth header:', error);
    return {};
  }
};

// Helper to clear all session caches on logout
const clearSessionCaches = () => {
    try {
        // Clear all sessionStorage on logout
        sessionStorage.clear();
    } catch (e) {
        console.error('Failed to clear session caches:', e);
    }
};

export const logout = async () => {
    try {
        const refreshToken = localStorage.getItem('refresh_token');
        if (refreshToken) {
            await axios.post(`${API_URL}/auth/logout/`,
                { refresh: refreshToken },
                getAuthHeader()
            );
        }
    } catch (error) {
        console.error('Logout error:', error);
    } finally {
        // Clear all session caches before clearing tokens
        clearSessionCaches();

        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('device_type');
        window.location.href = '/login';
    }
};